export const ApplicationCloseCodes = {
    UNEXPECTED_MESSAGE_TYPE: 4001,
    PLAYER_CONNECTED_TWICE: 4002,
    TIMEOUT: 4003,
    GAME_DOES_NOT_EXIST: 4004,
}
export default ApplicationCloseCodes;
